<template>
  <div class="system-merchant-help-container">
    <merchant-help-tree v-model="selectedHelpConfig"></merchant-help-tree>
    <div class="system-merchant-help-content">
      <el-scrollbar>
        <div v-if="selectedHelpConfig && selectedHelpConfig.parentId !== -1" class="ql-container">
          <div class="ql-editor" v-html="(selectedHelpConfig && selectedHelpConfig.content) || ''"></div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
// import { Message } from 'element-ui'
import PermissionButton from '@/components/Buttons/permission-button'
import LoadingButton from '@/components/Buttons/loading-button'
import MerchantHelpTree from './merchant-help-tree'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.min.js'

export default {
  name: 'systemMerchantHelp',
  components: {
    LoadingButton,
    PermissionButton,
    MerchantHelpTree
  },
  data() {
    return {
      selectedHelpConfig: undefined
    }
  },
  created() {},
  methods: {
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    helpConfigOnSelected(helpConfig) {
      this.selectedHelpConfig = helpConfig
    }
  }
}
</script>

<style lang="scss" scoped>
.system-merchant-help {
  &-container {
    height: 100%;
    display: flex;
    padding: 20px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}

.system-merchant-help-content {
  flex: 1;
  height: 100%;
  margin-left: 20px;
  overflow: hidden;

  .el-scrollbar {
    height: 100%;
  }

  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}

.myQuillEditor {
  height: 240px;
  padding-top: 0px;
  padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/help/components/merchant-help.vue